import { ISite, ISiteResponse } from '@shared/site.interface';
import {
  getSiteDetailsFailure,
  getSiteDetailsSuccess,
  loadingSiteDetails,
  loadingSites,
  searchSitesFailure,
  searchSitesSuccess,
} from './actions';
import { createReducer, on } from '@ngrx/store';

export const SITE_FEATURE_KEY = 'sites';

export interface SiteDetailsState {
  [siteId: string]: {
    site: ISite | null;
    loading: boolean;
    error: string | null;
  };
}

export interface SitesState {
  sites: ISiteResponse | null;
  sitesError: string | null;
  loading: boolean;
  siteDetails: SiteDetailsState;
}

export const initialState: SitesState = {
  sites: null,
  sitesError: null,
  loading: false,
  siteDetails: {},
};

export const sitesReducer = createReducer(
  initialState,
  on(loadingSites, (state) => ({ ...state, loading: true })),
  on(searchSitesSuccess, (state, { sites }) => ({
    ...state,
    sites,
    loading: false,
    sitesError: null,
  })),
  on(searchSitesFailure, (state, { error }) => ({
    ...state,
    sites: null,
    sitesError: error,
    loading: false,
  })),
  on(loadingSiteDetails, (state, { siteId }) => ({
    ...state,
    siteDetails: {
      ...state.siteDetails,
      [siteId]: { site: null, loading: true, error: null },
    },
  })),
  on(getSiteDetailsSuccess, (state, { site }) => ({
    ...state,
    siteDetails: {
      ...state.siteDetails,
      [site.id]: { site, loading: false, error: null },
    },
  })),
  on(getSiteDetailsFailure, (state, { siteId, error }) => ({
    ...state,
    siteDetails: {
      ...state.siteDetails,
      [siteId]: { site: null, loading: false, error },
    },
  })),
);
